import { render, staticRenderFns } from "./retail.vue?vue&type=template&id=4547d97d&scoped=true&"
import script from "./retail.vue?vue&type=script&lang=js&"
export * from "./retail.vue?vue&type=script&lang=js&"
import style0 from "./retail.vue?vue&type=style&index=0&id=4547d97d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4547d97d",
  null
  
)

export default component.exports